import { Event } from "../Event";

export class AsoControlFkCompanyIdEvents extends Event {
    public onChange = (value: any, setField: any, setState: any, formValues: any) => {
        this.setState("loadings", ["aso_control_fk_user_id"])

        if (value) {
            this.setField("aso_control_fk_user_id", {
                readonly: false
            })

            this.setFieldValue("aso_control_fk_user_id", "")
        } else {
            this.setField("aso_control_fk_user_id", {
                readonly: true
            })
        }

        setTimeout(() => {
            this.setState("loadings", [])
        }, 250)

    }
}